import {Module} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {FavoritesState} from "@service/store/types/FavoritesState";
import {actions} from "@service/store/favorites/actions";
import {state} from "@service/store/favorites/state";
import {mutations} from "@service/store/favorites/mutations";
import {getters} from "@service/store/favorites/getters";

const namespaced = true;

export const favorites: Module<FavoritesState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters
};
